if (location.hash) {               // do the test straight away
		window.scrollTo(0, 0);         // execute it straight away
		setTimeout(function() {
				window.scrollTo(0, 0);     // run it a bit later also for browser compatibility
		}, 1);
}

window.WebFontConfig = {
  google: { families: ['Oswald:700'] },
  custom: { families: ['YakuHanJP'],
            urls: ['https://cdn.jsdelivr.net/npm/yakuhanjp@3.1.0/dist/css/yakuhanjp.min.css?ver=5.3.2'] },
  active: function() {
    sessionStorage.fonts = true;
  }
};
(function() {
  var wf = document.createElement('script');
  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
  wf.type = 'text/javascript';
  wf.async = 'true';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wf, s);
})();

(function($){

	const navOpenBtn = document.querySelector('.gnav__Toggle');
	const navCloseBtn = document.querySelector('.gnav__ToggleClose');
	const navLink = document.querySelectorAll('.gnav__Menu1Link, .gnav__menu2 a');
	const body = document.body;
	const NavContainer = document.querySelector('.gnav__Container');
	const burgerNav = document.querySelector('.gnav__wrap');
	const NavBackground = document.querySelector('.js-offcanvas-overlay');
	// let clientWidth = body.clientWidth;
	// let noScrollBarWidth = clientWidth;
	// let diff = 0;


	$(navOpenBtn).click(function(){
		$(body).addClass('is-opened');
		$(NavContainer).fadeIn(200);
		$(NavContainer).addClass("isOpened");
		$(NavBackground).fadeIn(200);
	});
	$(navCloseBtn, navLink).click(function(){
		$(body).removeClass('is-opened');
		$(NavContainer).fadeOut(200);
		$(NavContainer).removeClass("isOpened");
		$(NavBackground).fadeOut(200);
	});

	$(NavBackground, NavContainer).on('click touchend', function(ev) {
		if (!$(ev.target).closest('.gnav__wrap').length) {
			$(body).removeClass('is-opened');
			$(NavContainer).fadeOut(200);
			$(NavContainer).removeClass("isOpened");
			$(NavBackground).fadeOut(200);
		}
		console.log("hey")
	});

	var $win = $(window);
			$header = $('#header');
			$gnav = $('#gnav');
	$win.on('scroll', function() {
		headerHeight = $header.outerHeight();
		headerPos = $header.offset().top;
		var value = $win.scrollTop();
		if ( value > headerHeight ) {
			$header.addClass('is-scrolled');
		} else {
			$header.removeClass('is-scrolled');
		}
		if ( value > 200 ) {
			$header.addClass('is-fixed');
			$gnav.addClass('is-fixed');
		} else {
			$header.removeClass('is-fixed');
			$gnav.removeClass('is-fixed');
		}
	});


	// var mq = matchMedia('(min-width: 768px)');
	// handle(mq);
	// mq.addListener(handle);
	// function handle(mq) {
	// 	if (mq.matches) {

	// 		$(body).removeClass('is-open');
	// 		$('#gnav__container, .gnav__wrap').css('display', '');

	// 		var headerH = 120;
	// 	} else {
	// 		$(navLink).on('click touchend', function() {
	// 			if ($(body).hasClass('is-open')) {
	// 				$(body).removeClass('is-open');
	// 				$(NavContainer).fadeOut(200);
	// 				$(NavBackground).fadeOut(200);
	// 			}
	// 		});
	// 		var headerH = 50;
	// 	}
	// 	var urlHash = location.hash;
	// 	if(urlHash) {
	// 		setTimeout(function(){
	// 			var target = $(urlHash);
	// 			var position = target.offset().top - headerH;
	// 			$('body,html').stop().animate({scrollTop:position}, 500);
	// 		}, 500);
	// 	}

	// 	$('a[href^="#"]').click(function() {
	// 		var href= $(this).attr("href");
	// 		var target = $(href == "#" || href == "" ? 'html' : href);
	// 		var position = target.offset().top - headerH;
	// 		$('body,html').stop().animate({scrollTop:position}, 500, 'swing');
	// 		return false;
	// 	});
	// }

	// $(window).scroll(function (){
	// 	$('.fadein, .scrlspy').each(function(){
	// 		var elemPos = $(this).offset().top;
	// 		var scroll = $(window).scrollTop();
	// 		var windowHeight = $(window).height();
	// 		if (scroll > elemPos - windowHeight){
	// 			$(this).addClass('scrollin');
	// 		}
	// 	});
	// });

})(jQuery);
